<agpr-dialog-container
    [id]="'wireCreateDialog'"
    [heading]="'Amplify.dialogs.newWire.heading'"
    [modal]="true"
    [draggable]="false"
    [contentPadding]="false"
    (close)="closeDialog()"
>
    <div class="agpr-wireCreateDialog-content">
        <div class="agpr-wireCreateDialog-leftPanel">
            <button
                class="agpr-wireCreateDialog-sidebarButton"
                id="wireCreateDialog_createNew"
                (click)="setCreateFromPrevious(false)"
                [ngClass]="{'agpr-wireCreateDialog-sidebarButton--active': !createFromPrevious}"
            >
                <span class="agpr-wireCreateDialog-sidebarButtonIcon">
                    <span class="agpr-i-line-release-new" aria-hidden="true"></span>
                </span>
                <span class="agpr-wireCreateDialog-sidebarButtonLabel">
                    {{ 'Amplify.dialogs.newWire.createNew' | localize }}
                </span>
            </button>
            <button
                class="agpr-wireCreateDialog-sidebarButton"
                id="wireCreateDialog_copyPast"
                (click)="setCreateFromPrevious(true)"
                [ngClass]="{'agpr-wireCreateDialog-sidebarButton--active': createFromPrevious}"
            >
                <span class="agpr-wireCreateDialog-sidebarButtonIcon">
                    <span class="agpr-i-line-release-past" aria-hidden="true"></span>
                </span>
                <span class="agpr-wireCreateDialog-sidebarButtonLabel">
                    {{ 'Amplify.dialogs.newWire.createFromPrevious' | localize }}
                </span>
            </button>
        </div>
        <agpr-scroll-panel>
            <div class="agpr-wireCreateDialog-rightPanel">
                <div
                    class="agpr-wireCreateDialog-createNew-wrapper"
                >
                    <agpr-wire-region-select
                        (wireRegionChange)="onWireRegionSelected($event)"
                    ></agpr-wire-region-select>
                    <div *ngIf="createFromPrevious">
                        <agpr-panel
                            [header]="'Amplify.dialogs.newWire.createFromPrevious.heading'"
                            [toggleable]="false"
                        >
                            <agpr-list-filter-select
                                [id]="'wireCreateDialog'"
                                class="agpr-wireCreateDialog-existingWires"
                                [list]="listItems"
                                [dropdownSelectorOptions]="contentSelectorOptions"
                                placeholder="Amplify.dialogs.newWire.createFromPrevious.filterTextInput.placeholder"
                                textInputAriaLabel="Amplify.dialogs.newWire.createFromPrevious.filterTextInput.placeholder"
                                listAriaLabel="Amplify.dialogs.newWire.createFromPrevious.existingWires"
                                noContentMessage="Amplify.dialogs.newWire.noReleasesFound"
                                (itemSelected)="onRowSelect($event)"
                                (dropdownChanged)="selectType($event)"
                            ></agpr-list-filter-select>
                        </agpr-panel>
                    </div>
                </div>
            </div>
        </agpr-scroll-panel>
    </div>

    <ng-template #footerLeft>
        <agpr-button
            label="Core.button.cancel"
            id="wireCreateDialog_cancelButton"
            [style]="buttonTypes.secondary"
            (click)="cancelClicked()"
        >
        </agpr-button>
    </ng-template>
    <ng-template #footerRight>
        <agpr-button
            id="wireCreateDialog_createButton"
            label="Amplify.dialogs.newWire.create"
            [disabled]="(createFromPrevious && !selectedItem) || (selectedWireRegion === wireRegionEnum.other) || !selectedWireRegion"
            [tooltip]="(createFromPrevious && !selectedItem) ? 'Amplify.dialogs.newWire.noReleaseSelected.tooltip' :
                ((selectedWireRegion === wireRegionEnum.other) ? 'Amplify.dialogs.newWire.otherRegionSelected.tooltip' : null)"
            (click)="createWire()"
            [style]="buttonTypes.primary"
        >
        </agpr-button>
    </ng-template>
</agpr-dialog-container>
